import angularModule from 'Navigation/angularModule/scripts/navigation_module';
import { VALAR_DOMAIN, VALAR_DOMAIN_STAGING } from 'PedagoDomainConstants';
import { DEFAULT_SIGNUP_LOCATION } from 'SignupLocations';

// oxlint-disable-next-line quantic/only-relative-within-module -- intentional absolute import for navigationHelper
import { navigationHelper } from 'NavigationHelpers';

/*
    Adds scope methods for route and url based navigation
*/

angularModule.factory('Navigation.NavigationHelperMixin', [
    '$injector',

    $injector => {
        const $window = $injector.get('$window');
        const isMobile = $injector.get('isMobile');
        const reactRouterBridge = $injector.get('reactRouterBridge');
        const ConfigFactory = $injector.get('ConfigFactory');

        const { getUrlPrefix, loadRoute, loadUrl, loadFaqUrl, goToMarketingHome } = navigationHelper();

        return {
            // FIXME: getUrlPrefix, loadRoute, and loadUrl are only here to not break
            // existing code referencing any of these functions.
            // We should refactor all references to use the `navigationHelper` module,
            // and fix up any specs.
            getUrlPrefix,
            loadRoute,
            loadUrl,
            loadFaqUrl,
            onLink(scope) {
                scope.getUrlPrefix = getUrlPrefix;
                scope.loadRoute = loadRoute;
                scope.loadUrl = loadUrl;
                scope.loadFaqUrl = loadFaqUrl;

                scope.openFAQ = () => {
                    scope.loadFaqUrl('/help', '_blank');
                };

                scope.gotoForgotPassword = preserveParams => {
                    const urlPrefix = scope.getUrlPrefix();

                    if ($window.CORDOVA && isMobile()) {
                        scope.loadRoute('/onboarding/hybrid/forgot-password', { preserveParams });
                    } else {
                        scope.loadRoute(`/${urlPrefix}forgot-password`, { preserveParams });
                    }
                };

                scope.gotoJoin = preserveParams => {
                    const urlPrefix = scope.getUrlPrefix();

                    if (urlPrefix.startsWith('valar')) {
                        const config = ConfigFactory.getSync();

                        if (config.appEnvType() === 'development') {
                            $window.location.assign(`http://localhost:8001${DEFAULT_SIGNUP_LOCATION}`);
                        } else if (config.appEnvType() === 'staging') {
                            $window.location.assign(`https://${VALAR_DOMAIN_STAGING}${DEFAULT_SIGNUP_LOCATION}`);
                        } else {
                            $window.location.assign(`https://${VALAR_DOMAIN}${DEFAULT_SIGNUP_LOCATION}`);
                        }
                    } else {
                        scope.loadRoute(`/${urlPrefix}join`, { preserveParams });
                    }
                };

                scope.gotoSignIn = (preserveParams, _urlPrefix = '') => {
                    const urlPrefix = _urlPrefix || scope.getUrlPrefix();
                    scope.loadRoute(`/${urlPrefix}sign-in`, { preserveParams });
                };

                scope.gotoMarketingHome = goToMarketingHome;

                scope.gotoHome = () => {
                    scope.loadRoute('/home');
                };

                scope.isActive = urls => {
                    for (let i = 0; i < urls.length; i++) {
                        if (reactRouterBridge.path().startsWith(urls[i])) {
                            return true;
                        }
                    }

                    return false;
                };
            },
        };
    },
]);
